import { Injectable } from '@angular/core';
import { FORM_STORAGE_KEY } from '@modules/funnel-form/form/consts/form.const';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  /**
   * Prefixos preservados em QUALQUER limpeza. As chaves aqui são por entidade (um rascunho e um
   * layout por fluxo), então não cabem na lista de nomes exatos: `omni-flow-draft-<id>` guarda o
   * rascunho não publicado do Editor de Jornada e `omni-flow-layout-<id>` as posições/cores dos
   * subfluxos. Sem isso, sair da conta (ou tomar um 401 no refresh) apagava trabalho não publicado —
   * o clear roda no signout, no interceptor de erro e na abertura da tela de login.
   */
  private static readonly KEEP_PREFIXES = [
    'omni-flow-draft-',
    'omni-flow-layout-',
    'omni-browser-id',
    // survives the clear() so a silent logout's reason can be reported on the next login
    'omni-last-signout',
  ];

  public clear(fieldsToKeep: string[] = []) {
    const keys = [...fieldsToKeep, FORM_STORAGE_KEY];

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && LocalStorageService.KEEP_PREFIXES.some((prefix) => key.startsWith(prefix))) {
        keys.push(key);
      }
    }

    const backupObject: Record<string, string | null> = {};
    for (const fieldName of keys) {
      backupObject[fieldName] = localStorage.getItem(fieldName);
    }

    localStorage.clear();

    for (const key in backupObject) {
      const value = backupObject[key];
      if (value !== null) {
        localStorage.setItem(key, value);
      }
    }
  }
}
